import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Observable } from "rxjs";
import { LocalStorageService } from "src/app/_services/local-storage.service";

@Component({
    selector: "app-jobboards",
    templateUrl: "./jobboards.component.html",
    styleUrls: ["./jobboards.component.scss"],
    standalone: false
})
export class JobboardsComponent implements OnInit {
  @Input() jobNumber: string;
  @Input() jobId: number = null;
  @Input() cancelText: string = "Skip";
  @Input() okText: string = "Attract Candidates";
  @Input() biasState: boolean = null;
  @Input() minJobboard: number = null;
  @Input() modalTitle: string = "Post to Free Job boards";
  @Input() modalSubtitle: string =
    "Publish the job details to the given job boards and start receiving applications";
  /**
   * Skip without making any toggle request to server
   */
  @Input() noSkipAction: boolean = false;

  errorState: string = null;

  mappedFreeJobboardState: any[] = [
    {
      jobboardid: 60,
      companyid: 7,
      name: "Monster",
      description: null,
      type: "Premium",
      logo: "https://logoswbtr.s3.us-west-2.amazonaws.com/v+copy.png",
      sitemapurl: null,
      isenable: 1,
      isactive: 1,
      createdon: "2021-02-24T11:35:09.000Z",
      createdby: null,
      updatedon: "2022-03-09T15:17:09.000Z",
      updatedby: null,
      keys: [
        {
          jobboardkeysid: 20,
          type: "username",
          value: "xwhitecrowrinxftp",
        },
        {
          jobboardkeysid: 21,
          type: "password",
          value: "xwh7dar6j1e",
        },
      ],
    },
    {
      jobboardid: 62,
      companyid: 7,
      name: "Google jobs",
      description:
        "Post to Google without any additional setup. Listing should take just about 24 hours.",
      type: "Free",
      logo: "https://logoswbtr.s3.us-west-2.amazonaws.com/v+copy+2.png",
      sitemapurl: null,
      isenable: 0,
      isactive: 1,
      createdon: "2021-02-24T11:35:28.000Z",
      createdby: null,
      updatedon: "2022-03-09T15:17:09.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 63,
      companyid: 7,
      name: "ZipRecruiter",
      description:
        "Post to ZipRecruiter without any additional setup. Listing should take just about 24 hours.",
      type: "Free",
      logo: "https://logoswbtr.s3.us-west-2.amazonaws.com/v+copy+3.png",
      sitemapurl: null,
      isenable: 0,
      isactive: 1,
      createdon: "2022-03-09T15:17:09.000Z",
      createdby: null,
      updatedon: "2022-03-09T15:17:09.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 64,
      companyid: 7,
      name: "Career site",
      description: "Post instantly! No additional setup required",
      type: "Free",
      logo: "https://logoswbtr.s3.us-west-2.amazonaws.com/v+copy+4.png",
      sitemapurl: null,
      isenable: 0,
      isactive: 1,
      createdon: "2022-03-09T15:17:09.000Z",
      createdby: null,
      updatedon: "2022-03-09T15:17:09.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 65,
      companyid: 7,
      name: "Naukri",
      description: "Using your Naukri recuiter account",
      type: "Premium",
      logo: "https://logoswbtr.s3.us-west-2.amazonaws.com/v.png",
      sitemapurl: null,
      isenable: 1,
      isactive: 1,
      createdon: "2022-03-09T15:17:09.000Z",
      createdby: null,
      updatedon: "2023-01-03T06:58:39.000Z",
      updatedby: null,
      keys: [
        {
          jobboardkeysid: 24,
          type: "Access Key",
          value: null,
        },
        {
          jobboardkeysid: 25,
          type: "Secret Key",
          value: null,
        },
      ],
    },
    {
      jobboardid: 66,
      companyid: 7,
      name: "LinkedIn Limited Listing",
      description:
        "Post to LinkedIn without any additional setup. Listing should take just about 24 hours.",
      type: "Free",
      logo: "https://newresumes.s3.us-west-2.amazonaws.com/LinkedIn.png",
      sitemapurl: null,
      isenable: 0,
      isactive: 1,
      createdon: "2022-03-09T15:17:09.000Z",
      createdby: null,
      updatedon: "2022-04-25T13:38:59.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 67,
      companyid: 7,
      name: "Indeed",
      description:
        "Post to Indeed without any additional setup. Listing should take just about 24 hours",
      type: "Free",
      logo: "https://wctest12.s3.us-west-2.amazonaws.com/3lizhzwmp.jpg",
      sitemapurl: "https://google.com",
      isenable: 0,
      isactive: 1,
      createdon: "2022-05-06T10:26:46.000Z",
      createdby: null,
      updatedon: "2022-07-14T08:08:23.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 69,
      companyid: 7,
      name: "Advemix",
      description:
        "Post to Advemix without any additional setup. Listing should take just about 3 hours",
      type: "Free",
      logo: "https://wctest12.s3.us-west-2.amazonaws.com/wnzki2tal",
      sitemapurl: null,
      isenable: 0,
      isactive: 1,
      createdon: "2022-05-12T13:08:35.000Z",
      createdby: null,
      updatedon: "2022-07-20T11:57:16.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 70,
      companyid: 7,
      name: "JobRapido",
      description:
        "Post to Jobrapido without any additional setup. Listing should take just about 24 hours",
      type: "Free",
      logo: "https://wctest12.s3.us-west-2.amazonaws.com/dxw1dpyjp",
      sitemapurl: null,
      isenable: 0,
      isactive: 1,
      createdon: "2022-05-12T13:08:35.000Z",
      createdby: null,
      updatedon: "2022-07-20T11:57:26.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 71,
      companyid: 7,
      name: "CareerJet",
      description:
        "Post to Careerjet without any additional setup. Listing should take just about 24 hours",
      type: "Free",
      logo: "https://wctest12.s3.us-west-2.amazonaws.com/b3gcin6xi",
      sitemapurl: null,
      isenable: 0,
      isactive: 1,
      createdon: "2022-05-12T13:10:10.000Z",
      createdby: null,
      updatedon: "2022-07-20T11:57:33.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 73,
      companyid: 7,
      name: "Talent",
      description:
        "Post to Talent without any additional setup. Listing should take just about 24 hours",
      type: "Free",
      logo: "https://wctest12.s3.us-west-2.amazonaws.com/991ceuepj",
      sitemapurl: null,
      isenable: 1,
      isactive: 1,
      createdon: "2022-06-16T07:17:49.000Z",
      createdby: null,
      updatedon: "2022-07-14T08:08:23.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 74,
      companyid: 7,
      name: "Post Job Free",
      description:
        "Post to Post Job Free without any additional setup. Listing should take just about 24 hours.",
      type: "Free",
      logo: "https://wctest12.s3.us-west-2.amazonaws.com/6aywagtqh",
      sitemapurl: null,
      isenable: 1,
      isactive: 1,
      createdon: "2022-08-17T14:29:55.000Z",
      createdby: null,
      updatedon: "2022-08-17T14:29:55.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 75,
      companyid: 7,
      name: "Recruit.net",
      description:
        "Post to recruit.net without any additional setup. Listing should take just about 24 hours",
      type: "Free",
      logo: "https://wctest12.s3.us-west-2.amazonaws.com/0nfjgchei",
      sitemapurl: null,
      isenable: 0,
      isactive: 1,
      createdon: "2022-08-26T12:27:34.000Z",
      createdby: null,
      updatedon: "2022-08-29T11:16:06.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 76,
      companyid: 7,
      name: "Flex jobs",
      description:
        "Post to flexjobs without any additional setup. Listing should take just about 24 hours",
      type: "Free",
      logo: "https://wctest12.s3.us-west-2.amazonaws.com/kjahod9qj",
      sitemapurl: null,
      isenable: 0,
      isactive: 1,
      createdon: "2022-08-26T12:27:34.000Z",
      createdby: null,
      updatedon: "2022-08-30T09:24:00.000Z",
      updatedby: null,
      keys: [],
    },
    {
      jobboardid: 77,
      companyid: 7,
      name: "Adzuna",
      description:
        "Post to Adzuna without any additional setup. Listing should take just about 24 hours",
      type: "Free",
      logo: "https://wctest12.s3.us-west-2.amazonaws.com/ho7u58oms",
      sitemapurl: null,
      isenable: 0,
      isactive: 1,
      createdon: "2022-08-30T05:35:29.000Z",
      createdby: null,
      updatedon: "2022-08-30T09:23:54.000Z",
      updatedby: null,
      keys: [],
    },
  ];
  freeJobboards: any[] = [];

  /**
   * Contains Job boards which was/is enabled (i.e. containing jobboard mapping)
   */
  enabledJobboards: any[] = [];

  // /**
  //  * Returns list of all FREE job board with enabled flag
  //  */
  // mappedFreeJobboardState: any[] = [];

  currentUser: any = null;

  constructor(private currentModal: NgbActiveModal) {}

  ngOnInit() {
    // if (!this.jobNumber) {
    //   return this.currentModal.dismiss('ERR_NO_JOBNUMBER')
    // } else {
    //   this.currentUser = this.localStorageService.getItem('user');
    //   if (this.jobId === null) this.getJobId();
    //   this.getGlobalJobboards();
    // }
  }

  // private getJobId() {
  //   this.jobService.getJobDetails(this.jobNumber).subscribe((res: any) => {
  //     if (res.status === "success") {
  //       this.jobId = res.message.jobdetails[0].jobid;
  //     } else {
  //       return this.currentModal.dismiss("ERR_NO_JOBID");
  //     }
  //   });
  // }

  // private getEnabledJobboards() {
  //   this.jobboardService
  //     .getjobsjobboards(this.jobNumber)
  //     .subscribe((res: any) => {
  //       if (res.status === "success") {
  //         this.enabledJobboards = res.message.map((m: any) => ({
  //           ...m,
  //           enabled: m.isenable == 1,
  //         }));
  //         this.mappedFreeJobboardState = this.freeJobboards.map((fjb) => ({
  //           ...fjb,
  //           enabled: this.enabledJobboards.some((ejb) =>
  //             this.biasState !== null && typeof this.biasState === "boolean"
  //               ? this.biasState
  //               : ejb.jobboardid == fjb.jobboardid && ejb.enabled
  //           ),
  //         }));
  //       } else {
  //         this.errorState =
  //           "We're experiencing some issues. You can post on job board at later stage, Please skip this step and continue your process!";
  //       }
  //     });
  // }

  // private getGlobalJobboards() {
  //   this.jobboardService
  //     .getjobboards(this.currentUser.companynumber)
  //     .subscribe((res: any) => {
  //       if (res.status === "success") {
  //         this.globalJobboards = res.message.map((m: any) => ({
  //           ...m,
  //           loading: false,
  //         }));
  //         this.freeJobboards = this.globalJobboards.filter(
  //           (jb) => jb.type === "Free"
  //         );
  //         this.getEnabledJobboards();
  //       } else {
  //         this.errorState =
  //           "We're experiencing some issues. You can post on job board at later stage, Please skip this step and continue your process!";
  //       }
  //     });
  // }

  // private buildActivityObject(jobboardId: number, toggleTo: boolean) {
  //   const activityObject = {
  //     action: "update",
  //     createdby: this.currentUser.userid,
  //     newvalue: toggleTo ? "1" : "0",
  //     oldvalue: toggleTo ? "0" : "1",
  //     primarykeyid: null,
  //     tablename: "jobsjobboardmapping",
  //     updatedfieldname: "isenable",
  //     userid: this.currentUser.userid,
  //   };
  //   const enableJobboardObject = this.enabledJobboards.find(
  //     (ejb) => ejb.jobboardid == jobboardId
  //   );
  //   if (enableJobboardObject) {
  //     activityObject.primarykeyid = enableJobboardObject.jobsjobboardmappingid;
  //   }
  //   return activityObject;
  // }

  // public updateJobboardStatus(
  //   jobboardId: number,
  //   toggleTo: boolean,
  //   overrideStateCheck = false,
  //   returnObservable = false
  // ): Observable<any> {
  //   this.errorState = null;
  //   if (
  //     !overrideStateCheck &&
  //     this.biasState !== null &&
  //     typeof this.biasState === "boolean"
  //   )
  //     return;
  //   const jobboardObject = this.mappedFreeJobboardState.find(
  //     (mfjb) => mfjb.jobboardid == jobboardId
  //   );
  //   jobboardObject.loading = true;
  //   const jobboardActivity = this.buildActivityObject(jobboardId, toggleTo);
  //   const requestBody = {
  //     companynumber: this.currentUser.companynumber,
  //     jobboardactivity: [jobboardActivity],
  //     jobboardname: jobboardObject.name,
  //     jobsjobboarddetails: {
  //       isenable: toggleTo ? 1 : 0,
  //       jobboardid: jobboardId,
  //       jobid: this.jobId,
  //       jobsjobboardmappingid: jobboardActivity.primarykeyid,
  //       updatedby: jobboardActivity.userid,
  //     },
  //   };
  //   const o = this.jobboardService.updatejobsjobboards(requestBody);
  //   !returnObservable &&
  //     o.subscribe(() => {
  //       this.getEnabledJobboards();
  //       jobboardObject.loading = false;
  //     });
  //   return returnObservable && o;
  // }

  // public async okProcess(popSuccess = true) {
  //   if (this.biasState === null) return;
  //   const excludeId = this.enabledJobboards.map((ejb) => ejb.jobboardid);
  //   const existingToggled = this.mappedFreeJobboardState.filter((mfjb) =>
  //     this.enabledJobboards.some(
  //       (ejb) =>
  //         mfjb.enabled !== ejb.enabled && mfjb.jobboardid == ejb.jobboardid
  //     )
  //   );
  //   const extraToggled = this.mappedFreeJobboardState.filter(
  //     (mfjb) => mfjb.enabled && !excludeId.includes(mfjb.jobboardid)
  //   );
  //   if (
  //     popSuccess &&
  //     this.minJobboard !== null &&
  //     typeof this.minJobboard === "number" &&
  //     this.minJobboard > 0 &&
  //     this.mappedFreeJobboardState.filter((mfjb) => mfjb.enabled).length <
  //       this.minJobboard
  //   ) {
  //     this.errorState = `Please select at least ${this.minJobboard} Job board to get applications`;
  //     return;
  //   }
  //   const allResolveable = [];
  //   [].concat(existingToggled, extraToggled).forEach((toBeToggled) => {
  //     allResolveable.push(
  //       this.updateJobboardStatus(
  //         toBeToggled.jobboardid,
  //         toBeToggled.enabled,
  //         true,
  //         true
  //       ).toPromise()
  //     );
  //   });
  //   await Promise.all(allResolveable);
  //   this.mappedFreeJobboardState = this.mappedFreeJobboardState.map(
  //     (m: any) => ({ ...m, loading: false })
  //   );
  //   popSuccess && this.currentModal.close("USER_SUCCESS");
  // }

  public async cancelProcess() {
    // this.mappedFreeJobboardState = this.mappedFreeJobboardState.map(
    //   (m: any) => ({
    //     ...m,
    //     enabled: m.name == "Career site" || m.name == "Indeed",
    //   })
    // );
    // if (!this.noSkipAction) {
    //   await this.okProcess(false);
    // }
    this.currentModal.dismiss("USER_CANCEL");
  }

  getToolTip(jobboard: any) {
    return `Job enabled on ${jobboard} as it is Published State`;
  }

  disableTooltipCareer(jobboard: any) {
    if (jobboard == "Career site" || jobboard == "Indeed") {
      return false;
    } else {
      return true;
    }
  }

  

 
}
